export type Locale = 'en' | 'ru';

import { en } from './locales/en';
import { ru } from './locales/ru';
import { useAppStore } from '@/store/appStore';

export const translations: Record<Locale, Record<string, string>> = {
    en,
    ru,
};

/**
 * Best-effort locale from the device/browser language. Used before a user is
 * loaded (e.g. the onboarding flow), where `user.locale` isn't available yet.
 * Russian → 'ru', everything else → 'en'.
 */
export const getDeviceLocale = (): Locale => {
    try {
        const lang = (navigator.language || navigator.languages?.[0] || 'en').toLowerCase();
        return lang.startsWith('ru') ? 'ru' : 'en';
    } catch {
        return 'en';
    }
};

export const useTranslation = (overrideLocale?: Locale) => {
    const { user } = useAppStore();
    const locale = overrideLocale || (user?.locale as Locale) || 'en';

    const t = (key: string, params: Record<string, string> = {}) => {
        const localeTranslations = translations[locale] || translations['en'];
        let translation = localeTranslations[key] || key;

        // Replace all placeholders
        Object.keys(params).forEach(param => {
            translation = translation.replace(`:${param}`, params[param]);
        });

        return translation;
    };

    return { t, locale };
};
